import Raven from 'raven-js';

const env = process.env.HOPS_ENV;
const sentryDSN = 'https://3e1bc4bd3b354d9c90dbac97b0842ee3@sentry-api.nwse.io/8';

const initSentry = () => {
  if (env !== 'dev') {
    Raven.config(sentryDSN, {
      env,
    }).install();
  }
};

const captureException = (error, info, tags) => {
  if (env !== 'dev') {
    Raven.captureException(error, {
      extra: info,
      tags,
      whitelistUrls: [/(preview|www)\.xing\.com/],
    });
  }
};

export { initSentry, captureException };
